<template>
  <relation-config
    :cur-input="curInput"
    :input-list="inputList"
    :rules="rules"
    :field-name="'multi_link'"></relation-config>
</template>
<script>
  import relationConfig from './relationConfig'
  export default {
    props: ['curInput', 'inputList'],
    data() {
      return {}
    },
    components: {
      relationConfig
    }
  }
</script>



// WEBPACK FOOTER //
// multirelateConfig.vue?759f7c3d